"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.camelizeDeep = void 0;

var _humps = require("humps");

var _mapKeysDeep = require("./mapKeysDeep");

var camelizeDeep = function camelizeDeep(obj) {
  var result = (0, _mapKeysDeep.mapKeysDeep)(obj, function (_, key) {
    return (0, _humps.camelize)(key);
  });
  return result;
};

exports.camelizeDeep = camelizeDeep;